/* eslint-disable no-useless-escape */
import { Modal, ModalBody } from "react-bootstrap";
import { popCancelBttn, imsLoader } from "../../assets";
import { Component } from "react";
import Button from "../Button";
import './GlobalSearchFeaturesPopUp.css'
import './BookmarkPopUp.css'
import ApiServices from "../../utils/apiServices";
import { LocationOrigin, getCurrentDate, snippetLongString } from "../../utils/utilityServices"
import AlertMessagePopUpModal from "./AlertMessagePopUpModal";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { Authentication } from "../../utils/authenticationUtilityServices";

let _locationOrigin = LocationOrigin;
class PubMedNotifyMeShareModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apiResponse: [],
      shared_to_email: '',
      error: '',
      confirmMessageContent: '',
      confirmMessageShowModal: false,
      confirmMessageIndex: -1,
      login_id: 0,
      prompt: '',
      template_name: '',
      alertMessageShowModal: false,
      alertMessageContent: '',
      alertMessageModelColor: "",
      formIsValid: true,
      isLoading: false
    };
  }
  // async componentDidMount() {
  //   this.setState({
  //     login_id: this.props.selectedPrompt?.[0]?.login_id,
  //     prompt: this.props.selectedPrompt?.[0]?.prompt,
  //     template_name: this.props.selectedPrompt?.[0]?.template_name
  //   })
  // }

  showConfirmMessage = (message, index) => {
    this.setState({
      confirmMessageContent: message,
      confirmMessageShowModal: true,
      confirmMessageIndex: index
    })
  }

  handleInput = (e) => {
    e.target.value = snippetLongString(e.target.value);
    this.setState({
      shared_to_email: e.target.value
    })
  }
  handleValidation = async () => {
    let errors = {};
    let form_Is_Valid = true;
    let service = new ApiServices();
    let sharedEmail = this.state.shared_to_email?.toLowerCase().trim();
    let username = JSON.parse(localStorage.getItem('username'));
    if (username) {
      username = username.toLowerCase();
    }
    let apiRes = await service.getUserDetailsByUserName(sharedEmail);    
    if (sharedEmail?.length === 0) {
      form_Is_Valid = false;
      errors["proptError"] = 'Please enter a valid email to proceed.';
    }
    else if (username?.toLowerCase() === sharedEmail?.toLowerCase()) {
      form_Is_Valid = false;
      errors["proptError"] = "Please use an email address other than yours's to share."
    }
    else if(sharedEmail.split('jnj.com').length > 2){
      form_Is_Valid = false;
      errors["proptError"] = "Please use only one user email address at a time."
    }
    else if (apiRes?.length === 0) {
      form_Is_Valid = false;
      errors["proptError"] = 'Email is not a registered mail.Please enter a registerd email.'
    }
    else if (!sharedEmail.includes('@its.jnj.com')) {
      form_Is_Valid = false;
      errors["proptError"] = `Email id must contain domain name ex: user@its.jnj.com`;
    }
    this.setState({ error: errors, formIsValid: form_Is_Valid });
    return {apiRes, form_Is_Valid};
  }

  errorAlertMessage = (message) => {
    this.setState({
      alertMessageContent: message,
      alertMessageModelColor: "#de1327",
      alertMessageShowModal: true
    })
  }

  successAlertMessage = (message) => {
    this.setState({
      alertMessageContent: message,
      alertMessageModelColor: "#2eb000",
      alertMessageShowModal: true
    })
  }

  generateDownloadTimestamp = () => {
    const now = new Date()
    return now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate() + "_" + now.getHours() + "-" + now.getMinutes() + "-" + now.getSeconds()
  }

  handleSubmit = async () => {    
    try {
      let service = new ApiServices();
      this.setState({isLoading: true})
      const {apiRes, form_Is_Valid} = await this.handleValidation()
      if (form_Is_Valid) {
        this.props.handleSubmit(this.state.shared_to_email)         
      }
    } catch(err) {
      console.log({err})
      this.errorAlertMessage("Something Went Wrong. Kindly try after some time.");      
    } finally {
      this.setState({isLoading: false})
    }        
  }

  closeAlertMessage = () => {
    this.setState({ showPop: false, alertMessageShowModal: false });
    this.props.handleClose(false);
  }

  render() {    
    const { isLoading, alertMessageContent, 
      alertMessageModelColor, alertMessageShowModal } = this.state;
    
    return (        
          <Modal
            show={this.props.showModal}
            size="lg md sm xs"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName="popup-transition"
            className="z-index-Share"
            backdropClassName="z-index-Share-backdrop"
            scrollable={true}
          >
            <div style={{ borderTop: `5px solid #EB1700`, overflow: "auto" }}>
              <div className="popup-cancel-btn-wrapper">
                <img
                  src={popCancelBttn}
                  alt=""
                  onClick={e => {
                    this.setState({ showPop: false });
                    this.props.handleClose(false);
                  }}
                />
              </div>
              <div>
                <Modal.Header className="gsfModalHeader" style={{ justifyContent: "left" }}>
                </Modal.Header>
                <Modal.Body scrollable={true} style={{ maxHeight: "40vh", padding: " 1rem 3rem" }}>
                  <div>
                    <span className="create-bookmark-field">
                      Enter the email address of the user you would like to share this   ​</span>
                    <br />
                    <input type="text" placeholder="ex: user@its.jnj.com​" value={this.state.bookmarkName} className="create-bookmark-input-box" onChange={this.handleInput}  /*onBlur={this.handleValidation}*/
                    />
                    <br />
                    {/*<span className="length-info">Name with a maximum of 100 characters.</span>*/}
                    <div className="errorInvalidName">{this.state.error["proptError"]}</div>
                  </div>
                </Modal.Body>
                <div className="bookmark-popup-button-wrapper" style={{ width: '22%' }}>
                  <Button text="Cancel" customColor="#000000" action={() => {
                    this.setState({ showPop: false });
                    this.props.handleClose(false);
                  }} />
                  <Button text="Share" customColor="#EB1700" action={this.handleSubmit} />
                </div>
              </div>
            </div>
            {alertMessageShowModal && <AlertMessagePopUpModal 
              color={alertMessageModelColor} 
              content={alertMessageContent} 
              showModal={alertMessageShowModal} 
              handleClose={() => this.closeAlertMessage()} />
            }
            {isLoading && <div
              style={{ 
                //border: '1px solid', 
                position: 'absolute', 
                textAlign: "center", 
                padding: "10%",
                width: '100%' 
              }}
            >
              <img
                src={imsLoader}
                alt="Loading Data"
                style={{ width: "10%" }}
              />
            </div>}
          </Modal>             
    );
  }
}

export default PubMedNotifyMeShareModal;